import {FormErrorType} from '@sharedComponents/PantaForm/types'
import {
    appendError,
    removeError,
    validateIsZipCode,
    validateRequired,
} from '@sharedComponents/PantaForm/utils'
import i18n from '@apps/Shared/translation/i18n'
import {IExtraPickupFormBody} from '@apps/Shared/Services/Pickups/interfaces'

export const LENGTH_CUSTOMER_NR = 7

export function validateCompanyName(
    companyName: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        companyName,
        'companyName',
        i18n.t('error.emptyCompanyName'),
        currentErrors
    )

    return errors
}

export const validateCustomerNr = (
    customerNr: string,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]
    errors = validateRequired(
        customerNr,
        'customerNr',
        i18n.t('error.emptyCustomerNr'),
        currentErrors
    )
    if (customerNr && customerNr.length != LENGTH_CUSTOMER_NR) {
        errors = appendError(
            errors,
            'customerNr',
            i18n.t('error.invalidCustomerNr')
        )
    } else {
        errors = removeError(
            errors,
            'customerNr',
            i18n.t('error.invalidCustomerNr')
        )
    }
    return errors
}

export function validateStreetAddress(
    streetAddress: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        streetAddress,
        'streetAddress',
        i18n.t('error.emptyStreetAddress'),
        currentErrors
    )
    return errors
}

export function validateZipCode(
    zipCode: string,
    currentErrors: FormErrorType[]
) {
    let errors = [...currentErrors]
    errors = validateRequired(
        zipCode,
        'zipCode',
        i18n.t('error.emptyZipCode'),
        errors
    )

    if (zipCode) {
        errors = validateIsZipCode(
            zipCode,
            'zipCode',
            i18n.t('error.incorrectZipCode'),
            errors
        )
    }

    return errors
}

export function validateCity(city: string, currentErrors: FormErrorType[]) {
    const errors = validateRequired(
        city,
        'city',
        i18n.t('error.emptyCity'),
        currentErrors
    )
    return errors
}

export function validateNumberOfBags(
    numberOfBags: string,
    currentErrors: FormErrorType[]
) {
    let errors = [...currentErrors]
    errors = validateRequired(
        numberOfBags,
        'numberOfBags',
        i18n.t('pickups.extraPickupForm.numberOfBagsError'),
        currentErrors
    )
    const parsedInt = parseInt(numberOfBags, 10)
    if (!isNaN(parsedInt) && parsedInt <= 0) {
        errors = appendError(
            errors,
            'numberOfBags',
            i18n.t('pickups.extraPickupForm.bagsMustBeMoreThanZeroError')
        )
    } else {
        errors = removeError(
            errors,
            'numberOfBags',
            i18n.t('pickups.extraPickupForm.bagsMustBeMoreThanZeroError')
        )
    }

    return errors
}

export function validateName(name: string, currentErrors: FormErrorType[]) {
    const errors = validateRequired(
        name,
        'name',
        i18n.t('error.emptyName'),
        currentErrors
    )

    return errors
}

export function validatePhone(phone: string, currentErrors: FormErrorType[]) {
    const errors = validateRequired(
        phone,
        'phone',
        i18n.t('error.emptyPhoneNumber'),
        currentErrors
    )

    return errors
}

export function validateEmail(email: string, currentErrors: FormErrorType[]) {
    let errors = validateRequired(
        email,
        'email',
        i18n.t('error.emptyEmail'),
        currentErrors
    )

    if (!_validateEmail(email)) {
        errors = appendError(errors, 'email', i18n.t('error.incorrectEmail'))
    } else {
        errors = removeError(errors, 'email', i18n.t('error.incorrectEmail'))
    }

    return errors
}

export function validateExtraContactName(
    name: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        name,
        'extraContactName',
        i18n.t('error.emptyName'),
        currentErrors
    )

    return errors
}

export function validateExtraContactPhone(
    phone: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        phone,
        'extraContactPhone',
        i18n.t('error.emptyPhoneNumber'),
        currentErrors
    )

    return errors
}

function _validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return re.test(String(email).toLowerCase())
}

export function validateForm(
    values: IExtraPickupFormBody,
    currentErrors: FormErrorType[]
) {
    let errors = [...currentErrors]

    errors = validateCustomerNr(values.customerNumber, errors)
    errors = validateCompanyName(values.companyName, errors)

    errors = validateCity(values.city, errors)
    errors = validateStreetAddress(values.streetAddress, errors)
    errors = validateZipCode(values.zipCode, errors)
    errors = validateNumberOfBags(values.numberOfBags, errors)

    errors = validateName(values.name, errors)
    errors = validatePhone(values.phoneNumber, errors)
    errors = validateEmail(values.emailAddress, errors)

    errors = validateExtraContactName(values.extraContactName, errors)
    errors = validateExtraContactPhone(values.extraContactphoneNumber, errors)

    return errors
}
